import { mediaQueries, useMediaQuery } from '@cascade/react-dom/hooks';
import { readStorageItem, writeStorageItem } from '@cascade/react-dom/utils';
import { Image } from '@cascade/ui-library';
import { useEffect, useState } from 'react';
import {
  advanceRotation,
  HERO_ROTATION_KEY,
  heroImages,
  toRotation,
} from './Hero.helpers.ts';
import classes from './Hero.module.scss';

export const Hero = () => {
  const isRegular = useMediaQuery(mediaQueries.regular);

  const [rotation] = useState(() => {
    const stored = readStorageItem(HERO_ROTATION_KEY, { isJson: true });
    const storedRotation = toRotation(stored);

    return advanceRotation(storedRotation, Date.now());
  });

  useEffect(() => {
    writeStorageItem(HERO_ROTATION_KEY, rotation, { isJson: true });
  }, [rotation]);

  return (
    <div className={classes.hero} aria-hidden='true'>
      {isRegular ? (
        <Image
          src={heroImages[rotation.index]}
          title=''
          fit='cover'
          className={classes.photo}
        />
      ) : null}
    </div>
  );
};
